import React from 'react';

import { Container } from 'theme/layout';
import { NakedIcon, VectorIconProps } from 'theme/icons';

const ICON_WIDTH = 12;

/**
 * Renders the input icon
 *
 * @param props - input icon props
 * @returns Input icon component
 */
export function InputIcon(props: VectorIconProps) {
  const { name, size, color } = props;

  if (!name) {
    return null;
  }

  return (
    <Container left="15px" position="absolute">
      <NakedIcon
        name={name}
        size={size}
        color={color}
        width={ICON_WIDTH}
      />
    </Container>
  );
}
